import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayersBehind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayersBehind"><Path d="M4 3V5H20V3H4Z" fill="currentColor"/><Path d="M2 7V20H22V7H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayersBehind;
